export default __webpack_public_path__ + "waves-testimonial-section.svg";